import { useQuery } from "@apollo/client";
import { DateFormat, DateFormatDoc } from "operations";

// All of these can assume the date is originally in MM/DD/YYYY format
const monthFirst = (date: string) => date;
const dayFirst = (date: string) => {
  const parts = date.split("/");
  return parts[1] + "/" + parts[0] + "/" + parts[2];
};
const yearFirst = (date: string) => {
  const parts = date.split("/");
  const year = parts[2].split(",");
  return (
    year[0] + "/" + parts[0] + "/" + parts[1] + (year[1] ? ", " + year[1] : "")
  );
};

const formatMap = {
  [DateFormat.DayFirst]: dayFirst,
  [DateFormat.YearFirst]: yearFirst,
  [DateFormat.MonthFirst]: monthFirst,
};

const formatTypeMap = {
  [DateFormat.DayFirst]: "DD/MM/YYYY",
  [DateFormat.YearFirst]: "YYYY/MM/DD",
  [DateFormat.MonthFirst]: "MM/DD/YYYY",
};

export const useDateFormatted = () => {
  const { data } = useQuery(DateFormatDoc);
  return (date: string) =>
    data?.viewingUser?.dateFormat && date
      ? formatMap[data?.viewingUser?.dateFormat](date)
      : date;
};

export const useDateFormatType = () => {
  const { data } = useQuery(DateFormatDoc);
  return data?.viewingUser?.dateFormat
    ? formatTypeMap[data.viewingUser.dateFormat]
    : "MM/DD/YYYY";
};
